import { render } from "./ViewRecord.vue?vue&type=template&id=c68be130&scoped=true"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"

import "@/components/modal-responsive.css?vue&type=style&index=0&id=c68be130&scoped=true&lang=css&external"
import "./ViewRecord.vue?vue&type=style&index=1&id=c68be130&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68be130"]])

export default __exports__